module.exports = __webpack_public_path__ + "img/rebrand_ui.97b9d358.svg";